import { render, staticRenderFns } from "./Regionpopup.vue?vue&type=template&id=5df80919&"
import script from "./Regionpopup.vue?vue&type=script&lang=js&"
export * from "./Regionpopup.vue?vue&type=script&lang=js&"
import style0 from "./Regionpopup.vue?vue&type=style&index=0&id=5df80919&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports